import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Accordion, Button, Card, Col, Dropdown, Row } from 'react-bootstrap';
import ShopOfferItem from '../../../common/ShopOfferItem/ShopOfferItem.jsx';
import PictureModalPlayer from '../../../common/Player/PictureModalPlayer.jsx';
import Picture from '../../../common/ShopOfferItem/Picture.jsx';
import ImageGalleryDropdown from '../../../common/ImageGalleryDropdown.jsx';
import FileListsModal from './FileListsModal.jsx';
import PlaylistsModal from './PlaylistModal/PlaylistsModal.jsx';
import SharedModal from './SharedModal.jsx';
import BuyButton from './BuyButton.jsx';
import { confirmAlert } from "react-confirm-alert";
import { useParams } from 'react-router-dom';


function ArrangementItem(props) {
  let { lang } = useParams();
  let [showPlaylist, setShowPlaylist] = useState(false);
  let [showSharedModal, setShowSharedModal] = useState(false);
  const tariffs_link = `/${lang}/tariffs/`;

  const handleClosePlaylistModal = () => setShowPlaylist(false);
  const handleShowPlaylistModal = () => setShowPlaylist(true);

  const handleCloseSharedModal = () => setShowSharedModal(false);
  const handleShowSharedModal = () => setShowSharedModal(true);

  const handleDeleteClick = () => {
    if (!props.downLoadUrl){
      props.onDelete([props.id])
    } else {
      confirmAlert({
        title: props.title,
        message: gettext('Вы оплатили покупку файлов данной аранжировки. Вы уверены, что хотите удалить её из коллекции?'),
        buttons: [
          {
            label: gettext('Да'),
            onClick: () => {
              props.onDelete([props.id])
            }
          },
          {
            label: gettext('Нет'),
            onClick: () => {}
          }
        ]
      });
    }
  };

  const can_open_online = props.user_can_open_online || props.can_open_online

  let files;
  let pdfFiles;
  if (props.files){
    files = props.files.map(f => <p className='mr-5 small'>
      <a href={ f.url } target='_blank'><i className={ 'icon icon-' + (f.pdf ? 'file-pdf' : 'doc') }></i>{ f.name }</a>
    </p>);
    if (can_open_online){
      pdfFiles = props.files.filter(f => f.pdf).map( f => ({ id: f.id, name: f.name }));
    }
  }
  const imageBlock = <Picture image={ props.thumbnail } title={ props.name } />
  const dropdownMenu = (
    <Dropdown>
      <Dropdown.Toggle variant={null} id={ 'dropdown-basic-' + props.id } size={'sm'}
                       className='menu-burger'>
        <i className="icon icon-menu"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item as="button" onClick={ handleShowPlaylistModal }>
          { gettext('Добавить в плейлист') }
        </Dropdown.Item>
        <Dropdown.Item as="button" onClick={ handleDeleteClick }>
          { gettext("Удалить из коллекции") }
        </Dropdown.Item>
        {/*<Dropdown.Item href="#/action-3">Оценить</Dropdown.Item>*/}
        <Dropdown.Item href={ props.url }>
          { gettext("Открыть в каталоге") }
        </Dropdown.Item>
        <Dropdown.Item as="button" onClick={ handleShowSharedModal }>
          { gettext('Поделиться') }
        </Dropdown.Item>
        {/*<Dropdown.Item href="#/action-3">Посмотреть другое от -> Автора, Исполнителя, Композитора</Dropdown.Item>*/}
      </Dropdown.Menu>
    </Dropdown>
  )

  let openOnlineBtn = null;
  if (props.button_open_online){
    if (pdfFiles){
      openOnlineBtn = <div className="d-flex flex-column"><ImageGalleryDropdown offerType={ props.offer_type }
                                           can_open_online={ can_open_online }
                                           btnVariant={ can_open_online ? 'green' : 'orange' }
                                           filesList={ pdfFiles }
                                           opener={ 'collection' }/></div>;
    }
    else {
      openOnlineBtn = <div className="d-flex flex-column"><a href={ tariffs_link } className={'btn btn-sm btn-orange white-space-nowrap mb-2 mb-md-0'}>
                       <i className='icon icon-file-pdf'></i> { gettext('Открыть Онлайн') }
                     </a></div>;
    }
  }

  return <ShopOfferItem {...props} type_icon={ null }
                        notShowPrice={ true } imageBlock={ imageBlock } topRightAngleMenu={ dropdownMenu }>
    <div className='d-flex flex-row flex-wrap mt-3 justify-content-between'>
      { openOnlineBtn }
      <div className="d-flex flex-column">
        <PictureModalPlayer code={ props.video_code } title={ props.title } author={ props.author }/>
      </div>
      <div className="d-flex flex-column">
        { props.downLoadUrl ? <Button href={ props.downLoadUrl } variant='outline-dark' size='sm'
                                     className='white-space-nowrap mb-2 mb-md-0'>
                                <i className='icon icon-floppy'></i> { gettext('Скачать файлы') }
                              </Button>
                            : <BuyButton id={ props.id }
                                         name={ props.name }
                                         price_format={ props.price_format }
                                         discount_price={ props.discount_price }
                                         discount={ props.discount }
                                         payment_service={ props.payment_service }/> }
      </div>
      <div className="d-flex flex-column">
        <FileListsModal files={files}/>
      </div>
    </div>
    <PlaylistsModal show={ showPlaylist }
                    onClose={ handleClosePlaylistModal }
                    offerId={ props.id }
                    playlists={ props.playlists }
                    inPlaylists={ props.inPlaylists }
                    onPlaylistChange={ props.onPlaylistChange }/>
    <SharedModal show={ showSharedModal }
                 onClose={ handleCloseSharedModal }
                 name={ props.name }
                 link={ props.url }/>
  </ShopOfferItem>
}

ArrangementItem.propTypes = {
  id: PropTypes.number.isRequired,
  downLoadUrl: PropTypes.string,
  can_open_online: PropTypes.bool.isRequired,
  can_download_files: PropTypes.bool.isRequired,
  payment_service: PropTypes.string.isRequired,
  tariff_link: PropTypes.string.isRequired,
}

export default compose(connect(null, {}))(ArrangementItem);

